var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChainLink = function SvgChainLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10 19-.172.172a4 4 0 0 1-5.657 0l-.343-.343a4 4 0 0 1 0-5.657L7.17 9.829a4 4 0 0 1 5.657 0l.343.343a4 4 0 0 1 1.14 2.328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.688 12.5a4 4 0 0 0 1.14 2.329l.343.343a4 4 0 0 0 5.657 0l3.343-3.343a4 4 0 0 0 0-5.657l-.343-.343a4 4 0 0 0-5.657 0L14 6"
  })));
};
export default SvgChainLink;